import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Box, Button, Card, CardMedia, Container, makeStyles } from '@material-ui/core';
import ReactPlayer from 'react-player';
import usePage from '@/hooks/usePage.js';
import Request from '@/helpers/request.js';
import Constants from '@/constants.js';
import mainStyles from '@/assets/js/mainStyles.js';

const useStyles = makeStyles(mainStyles);

const InnovationImplementation = () => {
  const classes = useStyles();
  const { id } = useParams();
  const [component, setComponent] = useState({});
  const { setTitle } = usePage();

  useEffect(async () => {
    const fetch = async () => {
      const response = await Request.get(`/p3d2-components/${id}`);
      setComponent(response);
    };
    setTitle('Mise en œuvre');

    await fetch();
  }, []);
  const componentData = component.usage
    ? component.usage
    : {
        text: '',
        video: '',
        image: null,
      };

  return (
    <Container maxWidth="md">
      <Box className={classes.descRoot}>
        <div className={classes.secTitle}>
          <span>{component?.title} </span>
        </div>
        <div className={classes.description}>{componentData.text}</div>
        {componentData.image && (
          <Card className={classes.imgCard}>
            <CardMedia
              className={classes.imgItem}
              component="img"
              image={`${Constants.BASE_URL}/${componentData.image.path} `}
            />
          </Card>
        )}
        {componentData?.video && (
          <Box justifyContent={'center'} className={classes.videoBox}>
            <ReactPlayer url={componentData?.video} width="100%" height="100%" controls />
          </Box>
        )}
        <Button
          className={classes.mainBtn}
          onClick={() => window.open('https://www.sateco.fr/fr/faq.html')}
          variant="outlined"
          size="large"
        >
          FAQ
        </Button>
      </Box>
    </Container>
  );
};

export default InnovationImplementation;
